import { useState, useEffect, useRef } from "react";
import ReactMarkdown from "react-markdown";

export default function MarketingBot() {

    const [input, setInput] = useState("");
    const [messages, setMessages] = useState([
        {
          sender: "bot",
          text: `👋 Welcome to MerinaSoft!
      
      I can help you with:
      
      • CRM Software
      • POS Software
      • Inventory Management
      • Custom Software Development
      • Mobile App Development
      
      Try asking:
      
      "Tell me about POS Software"
      
      or
      
      "I need a CRM System"`
        }
      ]);

    const [loading, setLoading] = useState(false);

    const bottomRef = useRef(null);

    useEffect(() => {

        if (
            !localStorage.getItem(
                "sessionId"
            )
        ) {

            localStorage.setItem(
                "sessionId",
                crypto.randomUUID()
            );

        }

    }, []);

    useEffect(() => {
        bottomRef.current?.scrollIntoView({
            behavior: "smooth"
        });
    }, [messages, loading]);

    useEffect(() => {

        const loadHistory =
            async () => {
    
                let sessionId =
                    localStorage.getItem(
                        "sessionId"
                    );
    
                if (!sessionId) {
    
                    sessionId =
                        crypto.randomUUID();
    
                    localStorage.setItem(
                        "sessionId",
                        sessionId
                    );
    
                }
    
                const response =
                    await fetch(
                        `http://62.146.238.66:10000/api/chat-history/${sessionId}`
                    );
    
                const data =
                    await response.json();
    
                if (data.length > 0) {
    
                    setMessages(data);
    
                }
    
            };
    
        loadHistory();
    
    }, []);

    const sendMessage = async () => {

        if (!input.trim() || loading) return;

        const userMessage = input;

        setMessages(prev => [
            ...prev,
            {
                sender: "user",
                text: userMessage
            }
        ]);

        setInput("");
        setLoading(true);

        try {

            const response = await fetch(
                "http://62.146.238.66:10000/api/chat",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json"
                    },
                    body: JSON.stringify({
                        sessionId:
                            localStorage.getItem(
                                "sessionId"
                            ),
                        message: userMessage
                    })
                }
            );

            const data = await response.json();

            setMessages(prev => [
                ...prev,
                {
                    sender: "bot",
                    text:
                        data.reply ||
                        "No response received."
                }
            ]);

        } catch (err) {

            setMessages(prev => [
                ...prev,
                {
                    sender: "bot",
                    text:
                        "Server unavailable. Please try again."
                }
            ]);

        } finally {

            setLoading(false);

        }
    };



    return (
        <div className="h-full flex flex-col">

            <div className="h-full flex flex-col bg-white overflow-hidden">

                {/* Header */}
                <div className="bg-blue-600 text-white px-6 py-4 flex justify-between items-center">

                    <div>

                        <h2 className="text-xl font-bold">
                            MerinaSoft AI Assistant
                        </h2>

                        <p className="text-sm opacity-90">
                            Ask anything about our products and services
                        </p>

                    </div>

                    <button
                        onClick={() => {

                            setMessages([]);

                            localStorage.removeItem(
                                "sessionId"
                            );

                            localStorage.setItem(
                                "sessionId",
                                crypto.randomUUID()
                            );

                        }}
                        className="
            px-3
            py-1
            text-xs
            bg-white/20
            rounded-lg
            hover:bg-white/30
            transition
        "
                    >
                        Clear
                    </button>

                </div>

                {/* Messages */}
                <div className="flex-1 overflow-y-auto p-5 bg-gray-50 min-h-0">


                    {messages.map((msg, index) => (

                        <div
                            key={index}
                            className={`mb-4 flex ${msg.sender === "user"
                                ? "justify-end"
                                : "justify-start"
                                }`}
                        >

                            <div
                                className={`max-w-[80%] px-4 py-3 rounded-2xl shadow-sm ${msg.sender === "user"
                                    ? "bg-blue-600 text-white"
                                    : "bg-white border border-gray-200 text-gray-800"
                                    }`}
                            >

                                <div className="text-xs font-semibold mb-1 opacity-70">
                                    {msg.sender === "user"
                                        ? "You"
                                        : "MerinaSoft AI"}
                                </div>

<div className="prose prose-sm max-w-none">
    <ReactMarkdown>
        {msg.text}
    </ReactMarkdown>
</div>

                            </div>

                        </div>

                    ))}

{messages.length === 1 &&
 messages[0].sender === "bot" && (

<div className="flex flex-wrap gap-2 mb-4">

  <button
    onClick={() =>
      setInput(
        "Tell me about POS Software"
      )
    }
    className="
      px-3
      py-2
      text-sm
      bg-white
      border
      border-gray-200
      rounded-full
      hover:bg-gray-100
    "
  >
    POS Software
  </button>

  <button
    onClick={() =>
      setInput(
        "Tell me about CRM Software"
      )
    }
    className="
      px-3
      py-2
      text-sm
      bg-white
      border
      border-gray-200
      rounded-full
      hover:bg-gray-100
    "
  >
    CRM Software
  </button>

  <button
    onClick={() =>
      setInput(
        "Tell me about Inventory Management System"
      )
    }
    className="
      px-3
      py-2
      text-sm
      bg-white
      border
      border-gray-200
      rounded-full
      hover:bg-gray-100
    "
  >
    Inventory
  </button>

</div>

)}

                    {loading && (

                        <div className="mb-4 flex justify-start">

                            <div
                                className="
      bg-white
      border
      border-gray-200
      rounded-2xl
      px-4
      py-3
    "
                            >
                                Typing...
                            </div>

                        </div>

                    )}

                    <div ref={bottomRef}></div>

                </div>

                {/* Input Area */}
                <div className="border-t border-gray-200 p-4 bg-white">

                    <div className="flex gap-3">

                        <input
                            value={input}
                            onChange={(e) =>
                                setInput(e.target.value)
                            }
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    sendMessage();
                                }
                            }}
                            placeholder="Type your question..."
                            className="
                    flex-1
                    h-12
                    px-4
                    border
                    border-gray-300
                    rounded-xl
                    outline-none
                    focus:ring-2
                    focus:ring-blue-500
                    focus:border-blue-500
                  "
                        />

                        <button
                            onClick={sendMessage}
                            className="
                    px-6
                    bg-blue-600
                    text-white
                    rounded-xl
                    font-semibold
                    hover:bg-blue-700
                    transition
                  "
                        >
                            Send
                        </button>

                    </div>

                </div>

            </div>

        </div>
    );

}